import { actionTypes, CompanyActions, CompanyState, InitialState } from './types'

const CompanyReducer = (state: CompanyState = InitialState, action: CompanyActions): CompanyState => {
  switch (action.type) {
    case actionTypes.SET_COMPANY_DATA:
      return {
        ...state,
        companyData: null,
        userData: null,
        isLogged: null,
        loading: true,
        error: false,
      }
    case actionTypes.SET_COMPANY_DATA_SUCCEEDED:
      return {
        ...state,
        companyData: action.payload.companyData,
        userData: action.payload.userData,
        isLogged: action.payload.isLogged,
        loading: false,
        error: false,
      }

    case actionTypes.SET_COMPANY_DATA_ERROR:
      return {
        ...state,
        companyData: null,
        userData: null,
        isLogged: null,
        loading: false,
        error: true,
      }
    case actionTypes.RESET_COMPANY_DATA:
      return {
        ...state,
        companyData: null,
        userData: null,
        isLogged: null,
        loading: false,
        error: false,
      }
    default:
      return state
  }
}

export default CompanyReducer
